import { Tooltip, type TooltipProps } from '@mantine/core';
import { createGlobalStyle, css } from 'styled-components';

const MantineTooltip = (props: TooltipProps) => {
  if (!props.label) {
    return props.children;
  }

  return (
    <>
      <GlobalTooltipStyles />
      <Tooltip
        maw={300}
        offset={8}
        multiline
        openDelay={300}
        transitionProps={{ duration: 0, transition: 'fade' }}
        {...props}
      />
    </>
  );
};

const GlobalTooltipStyles = createGlobalStyle(
  ({ theme }) => css`
    .mantine-Tooltip-tooltip {
      ${theme.typography.bodySm1};
      border-radius: ${theme.borderRadius.sm};
      color: ${theme.palette.neutral['00']};
      background-color: ${theme.palette.neutral[100]};
      padding: ${theme.spacing(1, 1.5)};
      line-height: 1.4;
      white-space: pre-wrap;
    }
  `
);

export default MantineTooltip;
